import axios from 'axios';
import { useAuthStore } from '../store/useAuthStore';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});


apiClient.interceptors.request.use((config) => {
    const token = useAuthStore.getState().accessToken;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});



apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        const isLoginRequest = originalRequest.url.includes('/api/auth/login');

        if (error.response?.status === 401 && !originalRequest._retry && !isLoginRequest) {
            originalRequest._retry = true;

            const refreshToken = useAuthStore.getState().refreshToken;

            if (refreshToken) {
                try {
                    // Logique de refresh...
                    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/refresh`, {
                        refreshToken
                    });
                    // ...
                } catch (refreshError) {
                    useAuthStore.getState().logout();
                    // On ne redirige que si on n'est pas déjà sur la page de login
                    if (!window.location.pathname.includes('/login')) {
                        window.location.href = '/login';
                    }
                    return Promise.reject(refreshError);
                }
            } else {
                useAuthStore.getState().logout();
                if (!window.location.pathname.includes('/login')) {
                    window.location.href = '/login';
                }
            }
        }

        // Si c'est une 401 sur le LOGIN, l'erreur est directement renvoyée au catch du handleSubmit
        return Promise.reject(error);
    }
);

export default apiClient;